import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { AlertController, IonicModule, ModalController } from '@ionic/angular';
import { AnimationService } from '../../services/animation.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../translate/translate.module';
import { TranslatePipe } from '../../translate/pipes/translate.pipe';

@Component({
  selector: 'app-info-alert',
  templateUrl: './info-alert.component.html',
  styleUrls: ['./info-alert.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class InfoAlertComponent {
  @Input() header: string;
  @Input() message: string;

  constructor(
    private alertController: AlertController,
    private animationService: AnimationService,
    private tp: TranslatePipe
  ) { }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: this.header,
      message: this.message,
      cssClass: 'info-alert',
      buttons: [
        {
          text: this.tp.transform('CLOSE'),
          role: 'cancel',
        }
      ],
      enterAnimation: (baseEl: HTMLElement) => {
        return this.animationService.dissolveDialogAnimation(baseEl, 0.75);
      },
      leaveAnimation: (baseEl: HTMLElement) => {
        return this.animationService.dissolveDialogReversedAnimation(baseEl, 0.75);
      },
      backdropDismiss: false
    });

    alert.addEventListener('ionAlertWillDismiss', async (event) => {
      if (event.detail.role === 'backdrop') {
        const alertElement = document.querySelector('.info-alert');
        if (alertElement) {
          const animation = this.animationService.dissolveDialogReversedAnimation(alertElement as HTMLElement, 0.75);
          await animation.play();
        }
      }
    });

    await alert.present();


    return alert;
  }
}
